import { render } from "./ListaNoticias.vue?vue&type=template&id=019fe7af"
import script from "./ListaNoticias.vue?vue&type=script&lang=js"
export * from "./ListaNoticias.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__